import { ButtonBase, styled } from '@mui/material';
import HeaderDropdown from 'components/Header/HeaderDropdown';
import { useApp } from 'contexts/app';
import { useAuth } from 'contexts/auth';
import { useNavigationGuard } from 'contexts/navigationGuard';
import { useHistory, useLocation } from 'react-router-dom';
import { Dropdown, Icon, Logo, NavButton, Stack } from 'shell/components';

const TimelyGraderLogo = () => {
    const history = useHistory();
    const { guard } = useNavigationGuard();

    return (
        <CustomButtonBase aria-label={'TimelyGrader'} onClick={() => guard(() => history.push('/'))}>
            <Logo />
        </CustomButtonBase>
    );
};

const Tablet = ({ navOptions, dropdownOptions }) => {
    const { course } = useApp();
    const { currentUser, changeAccount } = useAuth();
    const history = useHistory();
    const location = useLocation();
    const { guard } = useNavigationGuard();

    const renderNavOptions = () => {
        return (navOptions || []).map((navOption) => {
            if (navOption.options) {
                const activeOption = navOption.options.find(({ key }) => location.pathname.includes(key));
                const isActive = Boolean(activeOption);
                return (
                    <Dropdown
                        key={navOption.key}
                        id={`header-${navOption.key}-dropdown`}
                        align={'left'}
                        options={navOption.options}
                        rootComponent={
                            <NavButton active={isActive} startIcon={<Icon kind={navOption.icon} />}>
                                {navOption.text}
                                {isActive ? `/${activeOption.value}` : ''}
                            </NavButton>
                        }
                        onSelect={({ key }) => guard(() => history.push(`/${key}`))}
                    />
                );
            }

            return (
                <NavButton
                    key={navOption.key}
                    active={
                        navOption.link === '/'
                            ? location.pathname === '/'
                            : location.pathname.startsWith(navOption.link)
                    }
                    startIcon={<Icon kind={navOption.icon} />}
                    to={navOption.link}
                >
                    {navOption.text}
                </NavButton>
            );
        });
    };

    const handleSelect = ({ key }) => {
        if (key === 'profile') {
            return guard(() => history.push('/profile'));
        }
        if (key === 'course-settings') {
            return guard(() => history.push('/course-settings'));
        }
        if (key === 'switch-course') {
            return guard(() => changeAccount());
        }
        if (key === 'course-dashboard') {
            return guard(() => history.push('/'));
        }
    };

    return (
        <CustomStack alignItems={'center'} direction={'row'}>
            <Stack sx={{ height: '100%' }} alignItems={'center'} direction={'row'}>
                <TimelyGraderLogo />
                <Stack sx={{ ml: 4, height: '100%' }} direction={'row'} spacing={2}>
                    {renderNavOptions()}
                </Stack>
            </Stack>
            <HeaderDropdown
                id={'header-dropdown'}
                course={course}
                options={dropdownOptions}
                user={currentUser}
                onSelect={handleSelect}
            />
        </CustomStack>
    );
};

const CustomButtonBase = styled(ButtonBase)(({ theme }) => {
    return {
        '&:focus-visible': {
            borderRadius: '6px',
            outline: `${theme.palette.ensightful.secondary[400]} solid 3px`,
            outlineOffset: '4px',
        },
    };
});

const CustomStack = styled(Stack)(({ theme }) => {
    return {
        justifyContent: 'space-between',
        width: '100%',
        height: '100%',
        padding: theme.spacing(0, 5),
    };
});

export default Tablet;
